'use client'
import React, { useState } from 'react';

const ContactUs = () => {
    const [showContactDetails, setShowContactDetails] = useState(false);

    return (
        <div className="text-center flex flex-row items-center justify-center">
            {showContactDetails && (
                <div className="absolute flex flex-row sm:mb-36 mb-40 sm:mr-36 mr-[114px] space-x-8 p-4 items-baseline justify-center text-left bg-[#be9729] text-gray-900 border border-[#a98624] w-fit rounded-lg drop-shadow-lg"
                    onMouseEnter={() => setShowContactDetails(true)}
                    onMouseLeave={() => setShowContactDetails(false)}
                >
                    <div className='text-white'>
                        <h3 className='font-medium text-xl'>Facilities</h3>
                        <small className='font-semibold'>Email: <a className='hover:text-blue-600 hover:underline' href="mailto:gcfacilities@golubcapital.com">gcfacilities@golubcapital.com</a></small>
                    </div>
                    <div className='text-white'>
                        <h3 className='font-medium text-xl'>Technology</h3>
                        <small className='font-semibold'>Email: <a className='hover:text-blue-600 hover:underline' href="mailto:support@golubcapital.com">support@golubcapital.com</a></small>
                        <br />
                        <small className='font-semibold'>Phone: <a className='hover:text-blue-600 hover:underline' href="tel:1-855-465-8248">1-855-GOLUB-IT</a></small>
                    </div>
                </div>
            )}
            <div
                className="cursor-pointer p-8 font-medium text-sm text-gray-900 hover:text-gray-400"
                onMouseEnter={() => setShowContactDetails(true)}
                onMouseLeave={() => setShowContactDetails(false)}
            >
                CONTACT US
            </div>

        </div>
    );
};

export default ContactUs;
